import React from 'react';
import { motion } from 'framer-motion';
import { Partner } from './types';

interface PartnerCardProps {
  partner: Partner;
}

export function PartnerCard({ partner }: PartnerCardProps) {
  return (
    <motion.div
      className="rounded-2xl border border-gray-200 shadow-md hover:shadow-xl transition-shadow duration-300 p-6 bg-gradient-to-r from-blue-50 to-blue-100"
      whileHover={{ scale: 1.03 }}
    >
      <div className="flex flex-col items-center">
        <img
          src={partner.imageSrc}
          alt={`${partner.name} Logo`}
          className="w-32 h-32 object-contain mb-4"
        />
        <h3 className="text-2xl font-semibold text-gray-900 mb-2 text-center">
          {partner.name}
        </h3>
        <p className="text-gray-600 text-center mb-4">
          {partner.description}
        </p>
        <a
          href={partner.website}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-indigo-600 text-white font-medium py-2 px-8 rounded-full hover:bg-indigo-700 transition-colors"
        >
          Visit Website
        </a>
      </div>
    </motion.div>
  );
}
